/* 
©2018 EdgeVerve Systems Limited (a fully owned Infosys subsidiary),
Bangalore, India. All Rights Reserved. */

/* 
This polymer injects wrapper for all the authentication UI elements. 
The wrapper acts as a single end-point to generate any of the authentication UI element(e.g. transaction password, otp, debit card, etc). So whenever we need to include any authentication UI in our page, we pass the required information to this wrapper for the same. Then it is the responsibility of the wrapper to take care of data binding, UI element generation.

@demo bower_components/speedboat_ui/elements/demo/fin-auth-element-wrapper-demo.html
 */
import { Polymer, html } from '@polymer/polymer/polymer-legacy.js';
import './elements.js';
const template = html `<div id='authModeAnchor'></div>`;



Polymer({
    is: 'fin-auth-element-wrapper',
    _template: template,
    properties: {
        // if we need more modes of auth.
        //we should insert the relevant informations
        /** definition:This is an array of objects, with Method as mandatory field
                  method: defines the type of authentication method
                  resendUrl: if the authentication method has any resend urls
                  wrapperValue: Variable to be bind authentication pass codes.
              
        Here "authMethod" has to be a populated local variables of the callee. We are passing "authMethods" as an input to authentication element wrapper.
        For example if we were to generate 2 authentication elements namely 'TPWD'(for transaction password element) and 'OTP'(for OTP element). We already know that wrapperValue type for both OTP elements and transaction element is string and that OTP needs an extra variable called 'resend'.
        So following can be the value of authMethods:
        authMethod: {
           type: Array,
           value: [{method:"TPWD", wrapperValue:""}, {method="OTP", resend:"./random_link/", wrapperValue:""}]
        }
        */
        authMethod: {
            type: Array,
            value: [],
            // reflectToAttribute: true,
            // observer: "updateElements",
            notify: true
        },
        isvalid: {
            type: Boolean,
            notify: true
        },
        otpLink: {
            type: Boolean,
            notify: true
        },
        /**definition:
              method: defines the type of authenticaiton method
              elementName: label of the polymer element to be generated */
        authCategories: {
            type: Array,

            value: [{
                    method: 'OTP',
                    elementName: 'fin-auth-otp',
                },
                {
                    method: 'SOTP',
                    elementName: 'fin-auth-otp',
                },
                {
                    method: 'SPWD',
                    elementName: 'fin-auth-transaction-pwd',
                },
                {
                    method: 'TPWD',
                    elementName: 'fin-auth-transaction-pwd',
                },
                {
                    method: 'DBTCARD',
                    elementName: 'fin-auth-debit-card',
                },
                {
                    method: 'CRDCARD',
                    elementName: 'fin-auth-credit-card',
                },
                {
                    method: 'LGCC',
                    elementName: 'fin-auth-credit-card',
                },
                {
                    method: 'LGDC',
                    elementName: 'fin-auth-debit-card',
                },
                {
                    method: 'LGOTP',
                    elementName: 'fin-auth-otp',
                }
            ]
        },
        /** Internal to wrapper, to stop the observer being triggered before the ready is complete */
        wrapperReady: {
            type: Boolean,
            value: false,
            notify: false
        },
        userDetails: {
            type: Object,
            notify: true
        },
        customLabel: {
            type: String,
            notify: true
        }
    },
    observers: [
        'updateElements(authMethod.*)'
    ],

    /** Adds elements from authArray variable passed from host */
    updateElements: function() {
        //wait for ready to complete
        if (!(this.wrapperReady))
            return;
        if (this.authMethod) {
            if (this.authMethod.length == 0) {
                //console.log("clearing things");
                var node = this.$.authModeAnchor;
                while (node.hasChildNodes()) {
                    node.removeChild(node.lastChild);
                }
            }

            var self = this;
            this.authMethodLength = this.authMethod.length;

            for (var i = 0; i < this.authMethod.length; i++) {
                //check if the element is already rendered
                // if ("_auth_wrapper_index" in this.authMethod[i]) {
                //   continue;
                // }
                // if not rendered, start the rendering process
                //check for minimum requirements i.e 'method' and 'wrapperValue'
                if (!("method" in this.authMethod[i])) {
                    continue;
                } else if (!("wrapperValue" in this.authMethod[i])) {
                    continue;
                }
                if(!this.shadowRoot.querySelector("fin-auth-transaction-pwd")){
                // console.info(this.authMethod[i]);
                //Identify the category
                for (var j = 0; j < this.authCategories.length; j++) {
                    //category selected
                    
                    if (this.authMethod[i].method == this.authCategories[j].method) {
                        var authElement = document.createElement(this.authCategories[j].elementName);

                        if (this.authMethod[i].method == "SOTP") {
                            authElement.otpLink = (this.otpLink == undefined) ? true : this.otpLink;
                                authElement.customLabel = (this.customLabel == undefined) ? "" : this.customLabel;
                            authElement.resendUrl = (this.authMethod[i]["resendUrl"] == undefined) ? "" : this.authMethod[i]["resendUrl"];
                            authElement.corpId = (this.authMethod[i]["corpId"] == undefined) ? "" : this.authMethod[i]["corpId"];
                            authElement.userId = (this.authMethod[i]["userId"] == undefined) ? "" : this.authMethod[i]["userId"];
                            if (this.authMethod[i]["is_cust_assist"] == "Y") {
                                authElement.is_cust_assist = (this.authMethod[i]["is_cust_assist"] == undefined) ? "" : this.authMethod[i]["is_cust_assist"];
                                authElement.requested_by = (this.authMethod[i]["requested_by"] == undefined) ? "" : this.authMethod[i]["requested_by"];
                                authElement.access_token = (this.authMethod[i]["access_token"] == undefined) ? "" : this.authMethod[i]["access_token"];
                            }
                        }
						if (this.authMethod[i].method == "LGOTP") {
							authElement.otpLink = (this.otpLink == undefined) ? true : this.otpLink;
							authElement.resendUrl = (this.authMethod[i]["resendUrl"] == undefined) ? "" : this.authMethod[i]["resendUrl"];
							authElement.userDetails = (this.authMethod[i]["userDetails"] == undefined) ? "" : this.authMethod[i]["userDetails"];
						}

                        // pass all the attributes
                        for (var key in this.authMethod[i]) {
                            if (key == "method")
                                continue;
                            authElement.key = this.authMethod[i][key];
                        }
                        //added attribute to index the added elements
                        authElement["_auth_wrapper_index"] = i;
                        this.authMethod[i]["_auth_wrapper_index"] = i;
                        //adding event listener to support data binding for wrapperValue
                        authElement.addEventListener("wrapper-value-changed", function() {
                            // console.info("AuthElemet in the child element changed to ", this.wrapperValue, " ", self.authMethod[this.index]);
                            //self.authMethod[this["_auth_wrapper_index"]]['wrapperValue'] = this.wrapperValueInput;
                            //self.authMethod[this["_auth_wrapper_index"]]['wrapperEncryptedValue'] = this.wrapperValue;
                            self.authMethod[this["_auth_wrapper_index"]]['wrapperEncryptedValue'] = this.wrapperValue;
                            self.authMethod[this["_auth_wrapper_index"]]['wrapperValue'] = this.wrapperValue;
                        });
                        authElement.addEventListener("isvalid-changed", function(e) {
                            self.isvalid = e.detail.value;
                        });
                        this.$.authModeAnchor.appendChild(authElement);
                        break;
                    }
                }
            }
            }
        }
    },
    ready: function() {
        this.wrapperReady = true;
        this.updateElements();
    }
});